module.exports = __webpack_public_path__ + "img/img_kv_3_thumb.b41c3523.jpg";